var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('h1',[_c('span',{staticClass:"prefix"},[_vm._v("Logoly")]),_c('span',{staticClass:"postfix"},[_vm._v("Pro")])])])}]

export { render, staticRenderFns }